import type { Action } from 'svelte/action';

export const toggleClasses: Action<HTMLElement, Record<string, boolean>> = <
    T extends HTMLElement,
    Z extends Record<string, boolean>
>(
    node: T,
    tokens: Z
) => {
    let managedTokens: Z = tokens;
    const update = (tokens: Z) => {
        managedTokens = tokens;
        Object.entries(managedTokens).forEach(([key, value]) => node.classList.toggle(key, value));
    };
    const destroy = () => node.classList.remove(...Object.keys(managedTokens));
    update(tokens);
    return {
        destroy,
        update
    };
};
